import React, { Component, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import Body from '../Components/layout/Body';
import TextWithMoreInfo from '../Components/layout/TextWithMoreInfo';

const LANG_COG_HELP = `
  <div>
    <p><strong>Purpose: </strong>This is mainly a screening to see if there are cognitive or linguistic issues that may need additional support. Very generally, these may include:
      <ul>
        <li>Attention</li>        
        <li>Short-term Memory</li>        
        <li>Long-term Memory</li>
        <li>Problem solving</li>        
        <li>Receptive language</li>        
        <li>Expressive language</li>
        <li>Literacy</li>        
      </ul>
    </p>
    <p>Keeping tasks and displays as simple as possible can help accommodate some cognitive challenges (and is a good idea in general!).</p>
    <p><strong>Note: </strong>If the client has complex communication needs or significant cognitive challenges, you may need to look deeper into how to address those issues. For complex communication needs, be sure someone on the team has experience with language assessment and AAC intervention.</p>
  </div>
`
const propTypes = {
  strengths: PropTypes.string, 
  limitations: PropTypes.string, 
  onChangeStrengths: PropTypes.func.isRequired,
  onChangeLimitations: PropTypes.func.isRequired,
  saveFormData: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired
}

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  strengths: '',
  limitations: ''
};

class CognitionFeaturesForm extends Component {
  constructor(props){
    super(props);

    this.validate = this.validate.bind(this);
  }

  validate(){
  }

  //Render the form for entering cognitive strengths and limitations.
  //Calls the setter that's passed in by the parent, when a radio button is clicked.
  //That setter changes the state of the vars in the parent, 
  //which triggers a new render of the view with the new var values.


  render(){
    const strengths = this.props.strengths;
    const onChangeStrengths = this.props.onChangeStrengths;
    const limitations = this.props.limitations;
    const onChangeLimitations = this.props.onChangeLimitations;
    const onSubmit = this.props.onSubmit;

    return(
    <>
    {/* TODO Resolve. currently supports hitting Enter to submit (Continue) 
    https://ux.stackexchange.com/questions/130603/which-is-best-for-an-enter-note-field-an-enter-button-or-hitting-the-return-k
    Based on traditions of user interfaces, most users probably expect to press Enter OR 
    click a Save button to enter text in a field. 
    Giving both options often makes the most sense. 
    On the other hand, if saving the text also sends you to another screen, 
    then you want to prevent accidental actions, probably by not allowing Enter, 
    and by labeling the button "Save and Close" or "Save and Exit" or similar.
    */}
    <Form onSubmit={onSubmit}>
      <FormGroup>
        <Label for="strengths">
          <TextWithMoreInfo 
            text="Strengths:" 
            infoText="(such as: good literacy skills, ability to sustain attention)" 
          />
        </Label>
        <Input
          id="strengths"
          value={strengths}
          onChange={onChangeStrengths}
          name="strengths"
          type="textarea"
          // invalid={strengths !== ''}
        />
        {/* <FormFeedback>{methodNameError}</FormFeedback> */}
      </FormGroup>
      <FormGroup>
        <Label for="limitations">
          <TextWithMoreInfo 
            text="Limitations:" 
            infoText="(such as: complex communication needs, low alertness)" 
          />
        </Label>
        <Input
          id="limitations"
          value={limitations}
          onChange={onChangeLimitations}
          name="limitations"
          placeholder=""
          type="textarea"
        />
      </FormGroup>
      {' '}
    </Form>
    </>
  );
}
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function EvaluateAbilitiesCognitionFeatures(props) {
  const firstName = props.firstName;
  const pronouns = props.pronouns;
  const strengths = props.strengths;
  const onChangeStrengths = props.onChangeStrengths;
  const limitations = props.limitations;
  const onChangeLimitations = props.onChangeLimitations;
  const saveFormData = props.saveFormData;
  const onContinue = props.onContinue;

  // console.log("rendering EvaluateAbiltiiesCognitionFeatures with strengths: " + strengths);
  // console.log("rendering CurrentMethodEntry. callback type:  " + typeof(onChangeMethodName));

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used
    faIcon: "fa-puzzle-piece",
    pageSymbolClassName: "aa-section-symbol eval",
    title: `Now consider and list key features of ${firstName}'s language and cognitive abilities`,
    subTitle: `This can help you choose Activities and Access Methods that are a good fit for ${firstName}'s abilities.`,
    learnMore: {linkText: "Learn More about language and cognitive strengths and limitations",
                title: "Language and Cognition",
                content: LANG_COG_HELP
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: true,
  }

  useEffect(() => {
    console.log('EACog mounted');
    return () => {
      console.log('EACog unmounting and saving...');
      saveFormData();
    }
  }, [saveFormData])

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <CognitionFeaturesForm 
          firstName={firstName} 
          pronouns={pronouns}
          strengths={strengths} 
          onChangeStrengths={onChangeStrengths}
          limitations={limitations} 
          onChangeLimitations={onChangeLimitations}
          onSubmit={onContinue}
        />
      }
      onContinue={onContinue} 
    />
    </>
  );
}

EvaluateAbilitiesCognitionFeatures.propTypes = propTypes;
EvaluateAbilitiesCognitionFeatures.defaultProps = defaultProps;

export default EvaluateAbilitiesCognitionFeatures;

